module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3NCA3NCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ViNTUwNTt9LmJ7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+Y2hlY2stb2s8L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImEiIGN4PSIzNyIgY3k9IjM3IiByPSIzNyIvPjxwb2x5Z29uIGNsYXNzPSJiIiBwb2ludHM9IjU1LjE0IDI0LjAxIDU1LjE0IDI0LjAxIDU1LjE1IDI0LjAxIDU1LjE0IDI0LjAxIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik01NS4xNCwyM0wzMC4zNCw0Mi44OCwyMC4xOSwzMC43NGwtNi4yLDVMMjQuMTQsNDcuODVoMGw1LjA4LDYuMDcsMzEtMjQuODRaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/check-ok.svg
// module id = zvUO
// module chunks = 0